import React, { Component } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useCart } from '../../lib/cart';
export function Footer({
  forceEmilius = false
}: {
  forceEmilius?: boolean;
}) {
  const {
    slug: urlSlug
  } = useParams<{
    slug: string;
  }>();
  const {
    cart
  } = useCart();
  // Emilius "white-label" mode — sin links al marketplace de NOIZA.
  // Mismo discriminador que MarketplaceHeader: URL o slug del carrito.
  // `forceEmilius` cubre pantallas (ej. order-confirmation) donde la URL
  // no trae slug y el carrito ya fue vaciado tras el checkout.
  const isEmiliusFlow = forceEmilius || urlSlug === 'emilius-pizza' || cart.restaurantSlug === 'emilius-pizza';
  if (isEmiliusFlow) {
    return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-6 mt-auto" data-id="element-2390" data-mp="3j30gldw5u49j">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-2 text-center" data-id="element-2391" data-mp="3e1uit1nn7qt5">
          <p className="text-white/40 text-xs" data-id="element-2392" data-mp="39544ojvef5ad">
            © {new Date().getFullYear()} Emilius Pizza. Todos los derechos
            reservados.
          </p>
          <p className="text-[10px] tracking-wide text-white/25 select-none" aria-label="Powered by noizacr.com" data-id="element-2393" data-mp="2p3l1yiph5c0s">
            Powered by noizacr.com
          </p>
        </div>
      </footer>;
  }
  return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-12 mt-auto" data-id="element-2394" data-mp="2gcawpu53brg9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2395" data-mp="34258e8dob9yx">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-2396" data-mp="382fedl1gu0ds">
          <div className="col-span-1 md:col-span-2" data-id="element-2397" data-mp="380l5x67ds0ql">
            <div className="flex items-center gap-2 mb-4" data-id="element-2398" data-mp="2u3pgw4aqhyow">
              <div className="w-8 h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-2399" data-mp="2u5abftx1thmr">
                <span className="text-[#0B0B0B] font-bold text-lg leading-none" data-id="element-2400" data-mp="2z3u38aybpnn1">
                  N
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-2401" data-mp="1nn3zcyhdh7wl">
                NOIZA
              </span>
            </div>
            <p className="text-white/40 max-w-sm mb-6" data-id="element-2402" data-mp="13jy1mcbzy6cj">
              El marketplace gastronómico de Los Santos. Descubre, ordena y
              disfruta de los mejores restaurantes de la zona en un solo lugar.
            </p>
          </div>

          <div data-id="element-2403" data-mp="ptums6fg5ex4">
            <h4 className="font-semibold text-white mb-4" data-id="element-2404" data-mp="ps9smhx1nxzs">Explorar</h4>
            <ul className="space-y-3" data-id="element-2405" data-mp="ktzxg7bbkxe6">
              <li data-id="element-2406" data-mp="kv19of42npxh">
                <Link to="/" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2407" data-mp="kvjfa2cmjgi2">
                  Inicio
                </Link>
              </li>
              <li data-id="element-2408" data-mp="bvnztlc1czc8">
                <Link to="/restaurants" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2409" data-mp="6uqgh5fahz95">
                  Restaurantes
                </Link>
              </li>
              <li data-id="element-2410" data-mp="219ja4ywm4fyg">
                <Link to="/cart" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2411" data-mp="21916vibj91h1">
                  Carrito
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-2412" data-mp="2ii2dyenfq9es">
            <h4 className="font-semibold text-white mb-4" data-id="element-2413" data-mp="2ihk6elvbo8rk">Para Restaurantes</h4>
            <ul className="space-y-3" data-id="element-2414" data-mp="2ngncm9n1gl14">
              <li data-id="element-2415" data-mp="2nflrtdg80k67">
                <Link to="/onboarding" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2416" data-mp="2ng3sqndtvmkg">
                  Únete a NOIZA
                </Link>
              </li>

              <li data-id="element-2417" data-mp="1zrccmudiiuo1">
                <a href={`https://wa.me/50688118105?text=${encodeURIComponent('Hola, requiero soporte con: _________\n\nNombre del restaurante:\nCorreo electrónico registrado:\nNombre de quien contacta:')}`} target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2418" data-mp="1zr2u1rusrpsd">
                  Soporte
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-2419" data-mp="38sw143rf0bx7">
          <p className="text-white/30 text-sm" data-id="element-2420" data-mp="3nqocqktucg64">
            © {new Date().getFullYear()} NOIZA. Todos los derechos reservados.
            Los Santos, Costa Rica.
          </p>
          <div className="flex gap-4" data-id="element-2421" data-mp="jccpy7fys0y">
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-2422" data-mp="ib21uuc87jr">
              Términos
            </Link>
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-2423" data-mp="ac1l2k7p3ps2">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}